import { BankOutlineIcon } from '@components'
import cn from '@integrations/classnames'
import { NavLink } from '@integrations/routing'
import { uiSize } from '@utils'
import { paths } from 'mmfintech-backend-api'
import { tr } from 'mmfintech-commons'

interface Props {
  className?: string
  onClick: () => void
  showIcons?: boolean
}

function UserMenuItems({ className = '', onClick, showIcons = false }: Props) {
  return (
    <>
      <NavLink
        to={paths.settings()}
        onClick={onClick}
        className={({ isActive }) => cn(className, { 'active-tab': isActive })}
      >
        {showIcons && (
          <svg
            width={uiSize(15)}
            height={uiSize(15)}
            viewBox='0 0 24 24'
            fill='none'
            stroke='currentColor'
            strokeWidth='2'
          >
            <circle cx='12' cy='8' r='4' />
            <path d='M4 21v-1a6 6 0 0 1 6-6h4a6 6 0 0 1 6 6v1' />
          </svg>
        )}
        {tr('FRONTEND.HEADER.SETTINGS', 'Settings')}
      </NavLink>
      <NavLink
        to={paths.externalAccounts()}
        onClick={onClick}
        className={({ isActive }) => cn(className, { 'active-tab': isActive })}
      >
        {showIcons && <BankOutlineIcon size={15} />}
        {tr('FRONTEND.HEADER.EXTERNAL_ACCOUNTS', 'External accounts')}
      </NavLink>
    </>
  )
}

export default UserMenuItems
